export default __webpack_public_path__ + "static/media/logo-horizontal.981abe16.svg";